import { createRouter, createWebHistory } from 'vue-router';
import { authClient } from './auth';
import { ensureApiKeyStatus } from './composables/useApiKeyStatus';
import RootRedirect from './views/RootRedirect.vue';
import SignInView from './views/SignInView.vue';
import SignUpView from './views/SignUpView.vue';
import SettingsView from './views/SettingsView.vue';
import PrivacyView from './views/PrivacyView.vue';
import CurriculaView from './views/CurriculaView.vue';
import CurriculumDesignerView from './views/CurriculumDesignerView.vue';
import CurriculumDetailView from './views/CurriculumDetailView.vue';
import TutorView from './views/TutorView.vue';
import CurriculumReviewView from './views/CurriculumReviewView.vue';
import CurriculumItemsView from './views/CurriculumItemsView.vue';
import RetentionChatView from './views/RetentionChatView.vue';
import DecksView from './views/DecksView.vue';
import DeckDetailView from './views/DeckDetailView.vue';
import CardDesignerView from './views/CardDesignerView.vue';

const routes = [
  {
    path: '/',
    name: 'root',
    component: RootRedirect,
  },
  {
    path: '/sign-in',
    name: 'sign-in',
    component: SignInView,
  },
  {
    path: '/sign-up',
    name: 'sign-up',
    component: SignUpView,
  },
  {
    path: '/review',
    name: 'review',
    component: CurriculumReviewView,
  },
  {
    path: '/learn',
    name: 'learn',
    component: CurriculaView,
  },
  {
    path: '/learn/new',
    name: 'curriculum-designer',
    component: CurriculumDesignerView,
  },
  {
    path: '/learn/:id',
    name: 'curriculum-detail',
    component: CurriculumDetailView,
  },
  {
    path: '/learn/:id/tutor',
    name: 'tutor',
    component: TutorView,
  },
  {
    path: '/learn/:id/review',
    name: 'curriculum-review',
    component: CurriculumReviewView,
  },
  {
    path: '/learn/:id/items',
    name: 'curriculum-items',
    component: CurriculumItemsView,
  },
  {
    path: '/learn/:id/retention',
    name: 'curriculum-retention',
    component: RetentionChatView,
  },
  {
    path: '/decks',
    name: 'decks',
    component: DecksView,
  },
  {
    path: '/decks/:id',
    name: 'deck-detail',
    component: DeckDetailView,
  },
  {
    path: '/cards/new',
    name: 'card-designer',
    component: CardDesignerView,
  },
  {
    path: '/settings',
    name: 'settings',
    component: SettingsView,
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: PrivacyView,
  },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Gate learning routes behind a configured Anthropic API key. Without it,
// every LLM endpoint would fail; surfacing a "set your key" screen up-front
// is friendlier than letting the user get partway in.
router.beforeEach(async (to) => {
  if (
    !to.path.startsWith('/learn') &&
    !to.path.startsWith('/review') &&
    !to.path.startsWith('/cards')
  )
    return true;

  const session = await authClient.getSession();
  if (!session.data?.user) return true; // let unauthed users flow to existing redirects

  try {
    const status = await ensureApiKeyStatus();
    if (!status.hasKey) {
      return { path: '/settings', query: { needKey: '1' } };
    }
  } catch {
    // If the status check itself fails (e.g. backend down), don't block nav.
    return true;
  }
  return true;
});
